/**
 * Guess if a url points to an HLS manifest. We could actually fetch the
 * manifest and inspect it, or we could save time and bytes and just look for
 * an m3u8 extension.
 */
export const isHlsUrl = (url?: unknown): boolean =>
  typeof url === "string" && url.includes(".m3u8")
